import { motion } from 'framer-motion';
import { Building2, KeyRound, Users, Lock, UserCog, FileText, FolderOpen, Shield } from 'lucide-react';

const cards = [
  { icon: Building2, title: 'Organización privada', desc: 'Cada estudio trabaja dentro de su propio espacio de gestión.' },
  { icon: KeyRound, title: 'Separación por org_id', desc: 'Toda la información queda asociada a una organización específica.' },
  { icon: Users, title: 'Usuarios propios', desc: 'Cada organización administra sus propios accesos y equipo.' },
  { icon: Lock, title: 'Acceso seguro', desc: 'El ingreso al sistema se realiza desde cuentas registradas.' },
  { icon: UserCog, title: 'Roles y permisos', desc: 'Controlá qué puede ver o gestionar cada usuario.' },
  { icon: FileText, title: 'Documentos centralizados', desc: 'Ordená la documentación en un solo entorno de trabajo.' },
  { icon: FolderOpen, title: 'Gestión ordenada', desc: 'Causas, clientes, agenda y tareas conectadas en un mismo sistema.' },
  { icon: Shield, title: 'Control del equipo', desc: 'Mejor seguimiento interno para estudios con varios usuarios.' },
];

export default function SecuritySection() {
  return (
    <section id="seguridad" className="relative py-20 lg:py-28 bg-[#080808]" data-testid="security-section">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div initial={{ opacity: 0, y: 25 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
          className="text-center mb-14">
          <span className="text-[#C9A44C] text-[11px] uppercase tracking-[0.2em] block mb-3">Seguridad</span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-medium text-[#F8F6F0] tracking-tight mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Tu información jurídica en un <span className="text-[#C9A44C] italic">entorno privado</span>
          </h2>
          <p className="text-[#B8B8B8] text-sm max-w-2xl mx-auto leading-relaxed">
            Cada organización trabaja con sus propios datos, usuarios y permisos. LexOrbit fue diseñado para que cada estudio jurídico opere de forma independiente dentro del mismo sistema, evitando cruces de información entre organizaciones.
          </p>
        </motion.div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {cards.map((c, i) => {
            const Icon = c.icon;
            return (
              <motion.div key={i} initial={{ opacity: 0, y: 15 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                transition={{ duration: 0.35, delay: i * 0.06 }}
                className="bg-[#141414] border border-[rgba(201,164,76,0.12)] rounded-xl p-5 hover:border-[rgba(201,164,76,0.3)] transition-all duration-300"
                data-testid={`security-card-${i}`}>
                <Icon className="w-5 h-5 text-[#C9A44C] mb-3" strokeWidth={1.5} />
                <p className="text-[#F8F6F0] text-sm font-semibold mb-1.5">{c.title}</p>
                <p className="text-[#B8B8B8] text-[11px] leading-relaxed">{c.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
